import { render } from "./CarouselGallery.vue?vue&type=template&id=15a99d90&scoped=true"
import script from "./CarouselGallery.vue?vue&type=script&lang=js"
export * from "./CarouselGallery.vue?vue&type=script&lang=js"

import "./CarouselGallery.vue?vue&type=style&index=0&id=15a99d90&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15a99d90"]])

export default __exports__